import React, {Component} from "react";
import Head from "../../components/Head";
import {withTranslate} from "react-redux-multilingual";
import globalMiddleware from "../../hocs/globalMiddleware";
import ProgressiveImage from "react-progressive-image-loading";
import {setCurrentRoute} from "../../store/actions/globalActions";
import {connect} from "react-redux";


class DownloadForDoctors extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.setCurrentRoute(window.location.href);
    }


    state = {
        scroll: true,
    };


    render() {
        const history = [
            {
                page: this.props.translate("home"),
                to: "/"
            }
        ];


        return (
            <div id="download-for-doctor">

               {/* <Head title={this.props.translate("doctors")} history={history}/>*/}
                <div className="container">
                    <div className="row text-center flex flex-direction-row justify-content-center">
                        <div className="apps-header-image">
                            <ProgressiveImage
                                className="img-responsive"
                                preview="/images/doctor-image-placeholder.png"
                                src="/images/multiple-devices.png"
                                render={(src, style) => <img alt="device" src={src} style={style}/>}
                            />
                        </div>

                        <div className="col-md-12 content-area margin-top-50">
                            <h1 className="loon text-center">{this.props.translate("seena_for_doctors")}</h1>

                            <div className="btn-wrapper text-center">
                                <p className="text-center"> {this.props.translate("seena_for_doctors_desc")}
                                    <br/>
                                    {this.props.translate("seena_for_doctors_desc_two")}
                                </p>

                                <div className="sign-up">
                                    <a className="btn-style" target="_blank" rel="noopener noreferrer"
                                       href="https://admin-seena.com">{this.props.translate("sign_up_now")}</a>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 col-xs-12">

                                        <ProgressiveImage
                                            className="width-90"
                                            preview="/images/doctor-image-placeholder.png"
                                            src="/images/single.png"
                                            render={(src, style) => <img alt="device" src={src} style={style}/>}
                                        />

                                        <div className="mt-20 mb-20">
                                            <a className="btn" target="_blank" rel="noopener noreferrer"
                                               href="https://itunes.apple.com/us/app/seena-single-doctors/id1382204506?mt=8"><img
                                                className="img-responsive store"
                                                src="https://assets.tvplayer.com/web/images/new-theme/appstore-md.png"
                                                alt="Download TVPlayer onto your iPhone, iPad or iPod Touch"/></a>
                                            <a className="btn" target="_blank"
                                               rel="noopener noreferrer"
                                               href="https://play.google.com/store/apps/details?id=com.rkanjel.rklinicmanager&hl=en_US"><img
                                                className="img-responsive store"
                                                src="https://assets.tvplayer.com/web/images/new-theme/google-play-md.png"
                                                alt="Download TVPlayer onto your Android mobile or tablet"/></a>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xs-12">


                                        <ProgressiveImage
                                            className="width-90"
                                            preview="/images/doctor-image-placeholder.png"
                                            src="/images/poly.png"
                                            render={(src, style) => <img alt="device" src={src} style={style}/>}
                                        />


                                        <div className="mt-20 mb-20">
                                            <a className="btn" target="_blank"
                                               rel="noopener noreferrer"
                                               href="https://itunes.apple.com/us/app/seena-poly-clinics/id1447800839?mt=8"><img
                                                className="img-responsive store"
                                                src="https://assets.tvplayer.com/web/images/new-theme/appstore-md.png"
                                                alt="Download TVPlayer onto your iPhone, iPad or iPod Touch"/></a>
                                            <a className="btn" target="_blank"
                                               rel="noopener noreferrer"
                                               href="https://play.google.com/store/apps/details?id=com.rkanjel.rklinicpoly"><img
                                                className="img-responsive store"
                                                src="https://assets.tvplayer.com/web/images/new-theme/google-play-md.png"
                                                alt="Download TVPlayer onto your Android mobile or tablet"/></a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(DownloadForDoctors)))